// Dedicated Login Page Component — OAuth Only

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAniList } from '../context/AniListContext';
import { OAUTH_CONFIG } from '../config/constants';
import './Login.css';

const Login = () => {
    const navigate = useNavigate();
    const { connectAniList, isLoading } = useAniList();
    const [showPinInput, setShowPinInput] = useState(false);
    const [pinCode, setPinCode] = useState('');
    const [error, setError] = useState('');

    const handleOAuthConnect = () => {
        const authUrl = `${OAUTH_CONFIG.AUTHORIZE_URL}?client_id=${OAUTH_CONFIG.CLIENT_ID}&response_type=${OAUTH_CONFIG.RESPONSE_TYPE}`;
        window.open(authUrl, '_blank');
        setShowPinInput(true);
        setError('');
    };

    const handlePinSubmit = async (e) => {
        if (e) e.preventDefault();

        if (!pinCode.trim()) {
            setError('Please paste your access token');
            return;
        }

        setError('');

        const result = await connectAniList(pinCode.trim());

        if (result.success) {
            localStorage.setItem('active_anime_source', 'anilist');
            navigate('/dashboard');
        } else {
            setError(result.error || 'Invalid token. Please try again.');
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <div className="login-header">
                    <h1 className="app-title">Anivault</h1>
                    <p className="app-subtitle">Track Your Anime Journey</p>
                </div>

                <div className="login-content">
                    <div className="welcome-text">
                        <h2>Welcome! 👋</h2>
                        <p>Connect your AniList account to get started</p>
                    </div>

                    {!showPinInput ? (
                        <div className="login-form">
                            <button
                                onClick={handleOAuthConnect}
                                className="login-button"
                                disabled={isLoading}
                            >
                                🔗 Connect with AniList
                            </button>

                            <div className="login-footer">
                                <p className="help-text">
                                    Don't have an account? <a href="https://anilist.co/signup" target="_blank" rel="noopener noreferrer">Sign up</a>
                                </p>
                                <p className="privacy-note">
                                    🔒 Secure OAuth authentication via AniList
                                </p>
                            </div>
                        </div>
                    ) : (
                        <form onSubmit={handlePinSubmit} className="login-form">
                            <div className="pin-instructions">
                                <p><strong>1.</strong> Authorize on the AniList page that just opened</p>
                                <p><strong>2.</strong> Copy the access token shown</p>
                                <p><strong>3.</strong> Paste it below</p>
                            </div>

                            <div className="input-wrapper">
                                <label htmlFor="token">Access Token</label>
                                <input
                                    id="token"
                                    type="text"
                                    value={pinCode}
                                    onChange={(e) => setPinCode(e.target.value)}
                                    placeholder="Paste your access token here"
                                    className={error ? 'error' : ''}
                                    autoFocus
                                    disabled={isLoading}
                                />
                                {error && <div className="error-message">{error}</div>}
                            </div>

                            <button
                                type="submit"
                                className="login-button"
                                disabled={isLoading}
                            >
                                {isLoading ? 'Verifying...' : 'Submit Token'}
                            </button>

                            <div className="login-footer">
                                <button
                                    type="button"
                                    className="back-link"
                                    onClick={() => { setShowPinInput(false); setPinCode(''); setError(''); }}
                                >
                                    ← Back
                                </button>
                            </div>
                        </form>
                    )}
                </div>
            </div>

            <div className="login-background">
                <div className="gradient-orb orb-1"></div>
                <div className="gradient-orb orb-2"></div>
                <div className="gradient-orb orb-3"></div>
            </div>
        </div>
    );
};

export default Login;
